module.exports = __webpack_public_path__ + "img/Oman_logo.99789eaf.png";